import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axiosInterceptor from "./axiosInterceptors";
import { apiEndpoints } from "./ApiConfig";
import {
  getPostLoginRedirectPath,
  isAuthenticatedStatusResponse,
} from "./authStatus";
import PageLoader from "../Components/Loader/PageLoader";

const PublicOnlyRoute = () => {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [redirectPath, setRedirectPath] = useState("");

  useEffect(() => {
    axiosInterceptor
      .get(apiEndpoints.verifyTokenApi, { withCredentials: true })
      .then((res) => {
        if (isAuthenticatedStatusResponse(res)) {
          setRedirectPath(getPostLoginRedirectPath(res.data.role));
        } else {
          setRedirectPath("");
        }
      })
      .catch(() => {
        setRedirectPath("");
      })
      .finally(() => {
        setCheckingAuth(false);
      });
  }, []);

  if (checkingAuth) {
    return <PageLoader label="Loading" />;
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PublicOnlyRoute;
